import { filter } from 'lodash';

import * as ActionTypes from '../components/actions/types';

const initialState = {};

function cmsEventRankingAwardsReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CMS_EVENT_RANKING_AWARDS: {
      const { submissionId, payload } = action;
      return { ...state, [submissionId]: payload };
    }
    case ActionTypes.GIVE_CMS_EVENT_AWARD: {
      return {
        ...state,
        [action.submissionId]: {
          ...state[action.submissionId],
          awardsWon: [...state[action.submissionId].awardsWon, action.payload]
        }
      };
    }
    case ActionTypes.CANCEL_CMS_EVENT_AWARD: {
      return {
        ...state,
        [action.submissionId]: {
          ...state[action.submissionId],
          awardsWon: filter(
            state[action.submissionId].awardsWon,
            awd => awd !== action.payload
          )
        }
      };
    }
    default:
      return state;
  }
}

export default cmsEventRankingAwardsReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEventRankingAwards.js